import { getI18n, useTranslation } from "react-i18next";
import source from "./locales/en/common";
import type { ReactNode } from "react";

export type CommonTextKey = keyof typeof source;
/** Keys are authored display identities. Caller text and operational values stay literal. */
export function commonText(key: CommonTextKey, values?: Record<string, string | number>): string {
  const engine = getI18n();
  if (!engine?.isInitialized) return source[key].replace(/{{\s*(\w+)\s*}}/g, (_match, name: string) => String(values?.[name] ?? ""));
  return (engine as unknown as { t: (key: CommonTextKey, options: Record<string, unknown>) => string }).t(key, { ...values, ns: "common", keySeparator: false });
}
export function useCommonLanguage(): string {
  const { i18n } = useTranslation("common");
  return i18n.resolvedLanguage ?? i18n.language;
}
/** Keep rich values as React nodes; catalog text is never interpreted as HTML. */
export function commonNodes(key: CommonTextKey, values: Record<string, ReactNode>): ReactNode[] {
  const nodes = Object.values(values);
  const markers = Object.fromEntries(Object.keys(values).map((name, index) => [name, `\uFFF0${index}\uFFF1`]));
  return commonText(key, markers).split(/(\uFFF0\d+\uFFF1)/g).map(part => {
    const match = /^\uFFF0(\d+)\uFFF1$/.exec(part);
    return match ? nodes[Number(match[1])] : part;
  });
}
